import React from "react";
import './Footer.css';
const Footer =() =>{
    return(
        <div>
            <div className="footer"></div>
        </div>
    )
}

export default Footer;